
class SearchResultsParams {
  constructor(data) {
    const {

    } = data ?? {};

  }
}

export default SearchResultsParams;
